import { useReportsAmounts } from "@circle-react/components/SettingsApp/Moderation/useReportsAmounts";
import { useCommunityInboxStore } from "@circle-react/hooks/chatsV2/store";
import { useChatNotification } from "@circle-react/hooks/chatsV2/useChatNotification";
import { useIsConnectEnabled } from "@circle-react/hooks/useIsConnectEnabled";
import { usePendingConnections } from "@circle-react/hooks/usePendingConnections";
import { useSupportUnreadConversationsCount } from "@circle-react/pages/UnifiedInbox/hooks/useSupportUnreadConversationsCount";
import { useEffect } from "react";

export const useInboxHasUnread = (): boolean => {
  const { totalUnreadPausedAiChatsCount = 0, fetchPausedAiUnreadChatsCount } =
    useCommunityInboxStore();
  const { data: supportUnreadCount = 0 } = useSupportUnreadConversationsCount();
  const { unreadChatCount: dmUnreadCount = 0 } = useChatNotification();
  const { inboxCount: moderationInboxCount = 0 } = useReportsAmounts();
  const isConnectEnabled = useIsConnectEnabled();
  const { totalQueryAudience: connectionRequestsCount = 0 } =
    usePendingConnections({ options: { enabled: isConnectEnabled } });

  useEffect(() => {
    void fetchPausedAiUnreadChatsCount();
  }, [fetchPausedAiUnreadChatsCount]);

  return (
    totalUnreadPausedAiChatsCount > 0 ||
    supportUnreadCount > 0 ||
    dmUnreadCount > 0 ||
    moderationInboxCount > 0 ||
    connectionRequestsCount > 0
  );
};
